import { Card } from '@unistocks/components/layout/card';
import { Logo } from '@unistocks/components/logo/logo';
import { H1 } from '@unistocks/components/text/text';
import React, { PropsWithChildren } from 'react';
import { useMedia } from 'tamagui';

export type AuthContainerProps = PropsWithChildren<{
  title: string;
}>;

export const AuthContainer: React.FC<AuthContainerProps> = ({ children, title }) => {
  const media = useMedia();

  return media.sm ? (
    <Card overflow="hidden">
      <Card.Header fd={'column'} gap={'$4'}>
        <Logo pressable={false} w={'100%'} h={'$8'} />
        <H1 size={'$9'}>{title}</H1>
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card>
  ) : (
    children
  );
};

AuthContainer.displayName = 'AuthContainer';
